export default __webpack_public_path__ + "static/media/situation-coref-connect-entity.5c7b4cd9.gif";